import { ArrowRight, Construction, ShieldCheck } from "lucide-react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";

export default function PlaceholderPage({ title, description }) {
  const slug = title.toLowerCase().replaceAll(" ", "-");
  return (
    <div className="space-y-6" data-testid={`placeholder-${slug}-page`}>
      <section className="rounded-lg border border-slate-200 bg-white p-6" data-testid={`placeholder-${slug}-header`}>
        <Badge className="bg-blue-50 text-blue-900" data-testid={`placeholder-${slug}-badge`}><Construction className="mr-1 h-3 w-3" /> Modulo futuro</Badge>
        <h2 className="mt-4 font-heading text-4xl font-bold text-slate-950" data-testid={`placeholder-${slug}-title`}>{title}</h2>
        <p className="mt-3 max-w-2xl text-slate-600" data-testid={`placeholder-${slug}-description`}>{description}</p>
      </section>
      <Card className="rounded-lg border-slate-200 shadow-none" data-testid={`placeholder-${slug}-card`}>
        <CardContent className="grid gap-6 p-8 md:grid-cols-[auto_1fr_auto] md:items-center">
          <div className="flex h-14 w-14 items-center justify-center rounded-md bg-slate-100 text-blue-900" data-testid={`placeholder-${slug}-icon`}><ShieldCheck className="h-7 w-7" /></div>
          <div><p className="font-heading text-xl font-semibold text-slate-950" data-testid={`placeholder-${slug}-state-title`}>Struttura predisposta</p><p className="mt-1 text-sm text-slate-600" data-testid={`placeholder-${slug}-state-text`}>Il menu e l’area di lavoro sono già pronti per aggiungere workflow, tabelle e documenti DVR nella fase successiva.</p></div>
          <Button asChild variant="outline" data-testid={`placeholder-${slug}-companies-link`}><Link to="/aziende">Vai alle aziende <ArrowRight className="h-4 w-4" /></Link></Button>
        </CardContent>
      </Card>
    </div>
  );
}